import { j as r } from "../../../node_modules/react/jsx-runtime.js";
import { memo as R, useContext as q } from "react";
import { clsx as j } from "../../../node_modules/clsx/dist/clsx.m.js";
import G from "../Checkbox/Checkbox.js";
import J from "../Switch/Switch.js";
import { Typography as u } from "../Typography/Typography.js";
import { DropdownContext as O } from "../../molecules/Dropdown/DropdownContext.js";
import { Avatar as Q } from "../Avatars/Avatar.js";
import C from "../Icon/Icon.js";
import s from "./ListItem.module.scss.js";
import { DragHandler as U } from "./SortableList/helper.js";
import V from "../Badge/Badge.js";
import B from "../Tooltip/Tooltip.js";
const W = ({
  avatarSrc: v,
  checkbox: a,
  destructive: f,
  helperText: i,
  isDisabled: l = !1,
  isMultipleSelect: b,
  isSortable: n,
  leadingIcon: d,
  onClick: y,
  selected: o,
  switch: x,
  testId: t,
  text: g,
  value: F,
  size: m = "compact",
  trailingIcon: h,
  trailingIconTooltip: c,
  leadingIconTooltip: p,
  badge: N,
  data: H
}) => {
  const K = j(s.listItemContainer, s[m], {
    [s.disabled]: l,
    [s.destructive]: f,
    [s.selected]: o || (a == null ? void 0 : a.active),
    "cursor-pointer": !x
  }), $ = q(O), D = !!$, { onClickListItem: E } = $ || {}, k = (e) => {
    var L, A;
    const w = e.target.closest("svg");
    if (w && w.id === "clickable-trailing-icon" || ((A = (L = e.currentTarget.lastElementChild) == null ? void 0 : L.firstElementChild) == null ? void 0 : A.id) === "clickable-trailing-icon") {
      e.stopPropagation();
      return;
    }
    l || (D && E && E(e, { text: g, value: F, leadingIcon: d }), y && y(e, H));
  }, P = (e) => {
    e.key === "Enter" && k(e);
  };
  return /* @__PURE__ */ r.jsx("div", { className: "px-050 py-025", children: /* @__PURE__ */ r.jsxs(
    "div",
    {
      role: "option",
      "aria-selected": o,
      tabIndex: 0,
      className: K,
      onClick: l ? void 0 : k,
      onKeyDown: P,
      "aria-disabled": l,
      "data-testid": t,
      children: [
        n && /* @__PURE__ */ r.jsx(U, {}),
        !n && a && /* @__PURE__ */ r.jsx(G, { ...a }),
        /* @__PURE__ */ r.jsxs("div", { className: "flex items-center flex-1 gap-075", children: [
          !n && d && /* @__PURE__ */ r.jsx(
            B,
            {
              placement: "bottom",
              ...p,
              trigger: /* @__PURE__ */ r.jsx(
                C,
                {
                  id: (p == null ? void 0 : p.behavior) === "popover" ? "clickable-trailing-icon" : void 0,
                  name: d,
                  className: j({
                    "text-color-fg-brand-default": o,
                    "text-color-fg-bold": !o,
                    "text-color-fg-danger-default": f
                  }),
                  size: m == "extended" ? "md" : "sm"
                }
              ),
              disabledFocus: !0
            }
          ),
          !n && !d && v && /* @__PURE__ */ r.jsx(
            Q,
            {
              imageSrc: v,
              size: m === "extended" ? "m" : "sm",
              imageAlt: g,
              ...t && { testId: `${t}-avatar` }
            }
          ),
          /* @__PURE__ */ r.jsxs("div", { className: "flex flex-col gap-050 flex-1 justify-center", children: [
            /* @__PURE__ */ r.jsx(
              u,
              {
                text: g,
                variant: "interface/medium/sm",
                color: "color/fg/bold",
                textColor: f ? "color/fg/danger/default" : "color/fg/bold",
                ...t && { testId: `${t}-text` }
              }
            ),
            m === "extended" && i && /* @__PURE__ */ r.jsx(
              u,
              {
                text: i,
                variant: "interface/default/s",
                textColor: "color/fg/lighter",
                ...t && { testId: `${t}-helperText` }
              }
            )
          ] })
        ] }),
        m === "compact" && i && /* @__PURE__ */ r.jsx(
          u,
          {
            text: i,
            variant: "interface/default/s",
            textColor: "color/fg/lighter",
            ...t && { testId: `${t}-helperText` }
          }
        ),
        N && /* @__PURE__ */ r.jsx(
          V,
          {
            ...N,
            ...t && { testId: `${t}-badge` }
          }
        ),
        x && !b && /* @__PURE__ */ r.jsx(J, { ...x }),
        o && !x && !b && /* @__PURE__ */ r.jsx(C, { name: "check" }),
        !o && h && /* @__PURE__ */ r.jsx(
          B,
          {
            placement: "bottom",
            ...c,
            trigger: /* @__PURE__ */ r.jsx(
              C,
              {
                id: (c == null ? void 0 : c.behavior) === "popover" ? "clickable-trailing-icon" : void 0,
                name: h,
                className: j({
                  "text-color-fg-brand-default": o,
                  "text-color-fg-bold": !o,
                  "text-color-fg-danger-default": f
                })
              }
            ),
            disabledFocus: !0
          }
        )
      ]
    }
  ) });
}, mr = R(W);
export {
  W as ListItem,
  mr as default
};
//# sourceMappingURL=ListItem.js.map
